export const getDefaultState = () => {
  return {
    demo: null,
    information: {
      categoryAll: null,
      categoryYear: null,
      categoryName: null
    }
  }
}

const state = getDefaultState()
export default state
